import styled from "@emotion/styled";
import { Breakpoints, Icon, Theme } from "@ugc-ui/lego";
import { ListItemProps } from "./ListItem";

export const ListItemStyled = styled.div<
  Partial<ListItemProps> & { theme: Theme }
>`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  min-height: 40px;
  padding: 8px 16px;
  border-bottom: ${({ theme, isHiddenBorder }) =>
    `1px solid ${isHiddenBorder ? "transparent" : theme.gray.a10}`};
  transition: 0.3s;
  cursor: pointer;

  @media (min-width: ${Breakpoints.md}px) {
    &:hover {
      background-color: ${({ theme }) => theme.gray.a05};
      border-bottom: 1px solid transparent;
    }
  }
`;

export const ListItemContent = styled.div`
  flex: 1 1 auto;
`;

export const ListItemStartIcon = styled(Icon)`
  flex-shrink: 0;
  width: 24px;
  margin-right: 10px;
`;

export const ListItemEndIcon = styled(Icon)`
  flex-shrink: 0;
  width: 24px;
  margin-left: 6px;
`;
